/**
 * Auto-generated CRUD registry with lazy loading support
 * This file contains lightweight model registry and dynamic import functions
 * Generated by generate-crud-files.js - Do not edit manually
 */

// Import modules (lightweight, loaded upfront)
import module_Creator from 'src/CrudManager/Core/CrudModules/Creator/index'
import module_Editor from 'src/CrudManager/Core/CrudModules/Editor/index'
import module_Lister from 'src/CrudManager/Core/CrudModules/Lister/index'

// Import icons
import { symRoundedReceiptLong, symRoundedBusinessCenter, symRoundedStorefront, symRoundedRequestQuote, symRoundedCall, symRoundedLocalShipping, symRoundedConstruction, symRoundedReceipt, symRoundedGroups, symRoundedWarehouse } from '@quasar/extras/material-symbols-rounded'
import { mdiHeatingCoil } from '@quasar/extras/mdi-v7'

export const availableModulesList = [
  module_Creator,
  module_Editor,
  module_Lister,
];

// Lightweight model registry (no heavy configs loaded)
export const modelRegistry = [
  {
    name: 'bill',
    apiUrl: 'transaction',
    category: 'accounting',
    icon: symRoundedReceiptLong,
    permissionAlias: 'transaction',
    slugs: ['bills', 'bill', 'recus-dachat', 'recu-dachat', 'factures-achats', 'factures-fournisseurs'],
    importPath: 'src/CrudManager/CrudModels/bill/index',
  },
  {
    name: 'business_partner',
    apiUrl: 'business_partner',
    category: 'operations',
    icon: symRoundedBusinessCenter,
    slugs: ['business-partners', 'partenaires'],
    importPath: 'src/CrudManager/CrudModels/business_partner/index',
  },
  {
    name: 'equipment_for_sale',
    apiUrl: 'equipment_for_sale',
    category: 'administration',
    icon: symRoundedStorefront,
    slugs: ['equipment-for-sale', 'equipements-a-vendre'],
    importPath: 'src/CrudManager/CrudModels/equipment_for_sale/index',
  },
  {
    name: 'invoice',
    apiUrl: 'transaction',
    category: 'accounting',
    icon: symRoundedRequestQuote,
    permissionAlias: 'transaction',
    slugs: ['invoices', 'invoice', 'factures', 'facture'],
    importPath: 'src/CrudManager/CrudModels/invoice/index',
  },
  {
    name: 'part',
    apiUrl: 'part',
    category: 'operations',
    icon: mdiHeatingCoil,
    slugs: ['parts', 'pièces'],
    importPath: 'src/CrudManager/CrudModels/part/index',
  },
  {
    name: 'service',
    apiUrl: 'service',
    category: 'operations',
    disabled: true,
    slugs: ['services', 'service'],
    importPath: 'src/CrudManager/CrudModels/service/index',
  },
  {
    name: 'service_call',
    apiUrl: 'service_call',
    icon: symRoundedCall,
    slugs: ['appels-de-service', 'service-calls'],
    importPath: 'src/CrudManager/CrudModels/service_call/index',
  },
  {
    name: 'supplier',
    apiUrl: 'business_partner',
    category: 'accounting',
    icon: symRoundedLocalShipping,
    permissionAlias: 'business_partner',
    slugs: ['suppliers', 'supplier', 'fournisseurs', 'fournisseur'],
    importPath: 'src/CrudManager/CrudModels/supplier/index',
  },
  {
    name: 'task',
    apiUrl: 'task',
    category: 'operations',
    icon: symRoundedConstruction,
    disabled: true,
    slugs: ['tasks', 'tâches', 'task'],
    importPath: 'src/CrudManager/CrudModels/task/index',
  },
  {
    name: 'transaction',
    apiUrl: 'transaction',
    category: 'operations',
    icon: symRoundedReceipt,
    slugs: ['transactions', 'transaction'],
    importPath: 'src/CrudManager/CrudModels/transaction/index',
  },
  {
    name: 'user',
    apiUrl: 'user',
    category: 'administration',
    icon: symRoundedGroups,
    slugs: ['users', 'utilisateurs'],
    importPath: 'src/CrudManager/CrudModels/user/index',
  },
  {
    name: 'warehouse',
    apiUrl: 'warehouse',
    category: 'administration',
    icon: symRoundedWarehouse,
    slugs: ['warehouses', 'entrepots'],
    importPath: 'src/CrudManager/CrudModels/warehouse/index',
  },
]

// Dynamic import functions for lazy loading
const modelImporters = {
  bill: () => import('src/CrudManager/CrudModels/bill/index'),
  business_partner: () => import('src/CrudManager/CrudModels/business_partner/index'),
  equipment_for_sale: () => import('src/CrudManager/CrudModels/equipment_for_sale/index'),
  invoice: () => import('src/CrudManager/CrudModels/invoice/index'),
  part: () => import('src/CrudManager/CrudModels/part/index'),
  service: () => import('src/CrudManager/CrudModels/service/index'),
  service_call: () => import('src/CrudManager/CrudModels/service_call/index'),
  supplier: () => import('src/CrudManager/CrudModels/supplier/index'),
  task: () => import('src/CrudManager/CrudModels/task/index'),
  transaction: () => import('src/CrudManager/CrudModels/transaction/index'),
  user: () => import('src/CrudManager/CrudModels/user/index'),
  warehouse: () => import('src/CrudManager/CrudModels/warehouse/index'),
}

/**
 * Lazy loads a model configuration when needed
 * @param modelName - Name of the model to load
 * @returns Promise resolving to the full model configuration
 */
export async function loadModel(modelName: string) {
  const importer = modelImporters[modelName]
  if (!importer) {
    throw new Error(`Model '${modelName}' not found in registry`)
  }
  const module = await importer()
  return module.default
}

/**
 * Gets basic model metadata without loading full configuration
 * @param modelName - Name of the model
 * @returns Basic model metadata or undefined if not found
 */
export function getModelMetadata(modelName: string) {
  return modelRegistry.find((model) => model.name === modelName)
}

// Legacy export for backward compatibility (will be deprecated)
// This loads all models - use loadModel() for better performance
export async function getAllModels() {
  console.warn('getAllModels() is deprecated. Use loadModel() for better performance.')
  const models = await Promise.all(
    Object.keys(modelImporters).map(async (name) => {
      const module = await modelImporters[name]()
      return module.default
    }),
  )
  return models
}
